import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";

import { useState, useEffect } from "react";

import { getAge, isValidEmail } from "../NewStudentForm";

export default function ParentsDetailsPhase(props) {
  const setCurrentStep = props.setCurrentStep;
  const setNewParentsData = props.setNewParentsData;
  const newParentsData = props.newParentsData;
  const newStudentData = props.newStudentData;
  const paymentCheck = props.paymentCheck;
  const formConfig = props.formConfig;

  const studentAge = getAge(
    new Date(
      newStudentData.birthYear,
      newStudentData.birthMonth - 1,
      newStudentData.birthDay
    )
  );

  const [parentOneName, setParentOneName] = useState(
    studentAge < 19
      ? newParentsData.parentOneName
        ? newParentsData.parentOneName
        : ""
      : newStudentData.personalName
        ? newStudentData.personalName
        : ""
  );
  const [parentOneNameTouched, setParentOneNameTouched] = useState(false);
  const [parentOneNameValid, setParentOneNameValid] = useState(false);

  const [parentOnePhone, setParentOnePhone] = useState(
    newParentsData.parentOnePhone ? newParentsData.parentOnePhone : ""
  );
  const [parentOnePhoneTouched, setParentOnePhoneTouched] = useState(false);
  const [parentOnePhoneValid, setParentOnePhoneValid] = useState(false);

  const [parentOneMail, setParentOneMail] = useState(
    newParentsData.parentOneMail ? newParentsData.parentOneMail : ""
  );
  const [parentOneMailTouched, setParentOneMailTouched] = useState(false);
  const [parentOneMailValid, setParentOneMailValid] = useState(false);

  const [parentTwoName, setParentTwoName] = useState(
    newParentsData.parentTwoName ? newParentsData.parentTwoName : ""
  );
  const [parentTwoNameTouched, setParentTwoNameTouched] = useState(false);
  const [parentTwoNameValid, setParentTwoNameValid] = useState(false);

  const [parentTwoPhone, setParentTwoPhone] = useState(
    newParentsData.parentTwoPhone ? newParentsData.parentTwoPhone : ""
  );
  const [parentTwoPhoneTouched, setParentTwoPhoneTouched] = useState(false);
  const [parentTwoPhoneValid, setParentTwoPhoneValid] = useState(false);

  const [parentTwoMail, setParentTwoMail] = useState(
    newParentsData.parentTwoMail ? newParentsData.parentTwoMail : ""
  );
  const [parentTwoMailTouched, setParentTwoMailTouched] = useState(false);
  const [parentTwoMailValid, setParentTwoMailValid] = useState(false);

  // Helper function to validate all fields
  const validateFields = () => {
    // Always validate for button state
    setParentOneNameValid(parentOneName.trim().length > 0);
    setParentOnePhoneValid(parentOnePhone.trim().length === 10);
    setParentOneMailValid(isValidEmail(parentOneMail));
    // Parent 2 fields are optional, so we don't need to validate them
    setParentTwoNameValid(true);
    setParentTwoPhoneValid(true);
    setParentTwoMailValid(true);
  };

  // Validate fields on initial render
  useEffect(() => {
    // If there's pre-filled data, mark the fields as touched and validate them
    if (newParentsData.parentOneName) {
      setParentOneNameTouched(true);
    }
    if (newParentsData.parentOnePhone) {
      setParentOnePhoneTouched(true);
    }
    if (newParentsData.parentOneMail) {
      setParentOneMailTouched(true);
    }
    if (newParentsData.parentTwoName) {
      setParentTwoNameTouched(true);
    }
    if (newParentsData.parentTwoPhone) {
      setParentTwoPhoneTouched(true);
    }
    if (newParentsData.parentTwoMail) {
      setParentTwoMailTouched(true);
    }
    validateFields();
  }, []);

  // Validate fields whenever any input changes
  useEffect(() => {
    validateFields();
  }, [
    parentOneName,
    parentOnePhone,
    parentOneMail,
    parentTwoName,
    parentTwoPhone,
    parentTwoMail,
    studentAge,
  ]);

  return (
    <div className="contentContainer">
      <h2 className="text-center mb-4">פרטי קשר</h2>
      <Form className="formStyles">
        <Form.Group className="mb-3">
          {studentAge < 19 ? (
            <>
              <p className="newtext mb-2">פרטי הורה 1*</p>
              <Form.Control
                type="text"
                style={{ marginBottom: "10px" }}
                className="formField"
                placeholder={`שם*`}
                value={parentOneName}
                id="personalName"
                onChange={(e) => {
                  setParentOneName(e.target.value);
                }}
                onBlur={() => {
                  setParentOneNameTouched(true);
                }}
                isInvalid={parentOneNameTouched && !parentOneNameValid}
              />
            </>
          ) : null}
          <Form.Control
            type="text"
            className="formField"
            placeholder={`מייל*`}
            value={parentOneMail}
            style={{ marginBottom: "10px" }}
            id="personalName"
            onChange={(e) => {
              setParentOneMail(e.target.value);
            }}
            onBlur={() => {
              setParentOneMailTouched(true);
            }}
            isInvalid={parentOneMailTouched && !parentOneMailValid}
          />
          <Form.Control
            type="text"
            className="formField"
            placeholder={"טלפון*"}
            value={parentOnePhone}
            style={{ marginBottom: "10px" }}
            id="personalName"
            onChange={(e) => {
              setParentOnePhone(e.target.value);
            }}
            onBlur={() => {
              setParentOnePhoneTouched(true);
            }}
            isInvalid={parentOnePhoneTouched && !parentOnePhoneValid}
          />
        </Form.Group>
        {studentAge < 19 ? (
          <>
            <p className="newtext mb-2">פרטי הורה 2</p>
            <Form.Group className="parentField">
              <Form.Control
                type="text"
                className="formField"
                placeholder="שם"
                value={parentTwoName}
                style={{ marginBottom: "10px" }}
                id="personalName"
                onChange={(e) => {
                  setParentTwoName(e.target.value);
                }}
                onBlur={() => {
                  setParentTwoNameTouched(true);
                }}
                isInvalid={parentTwoNameTouched && !parentTwoNameValid}
              />
              <Form.Control
                type="text"
                className="formField"
                style={{ marginBottom: "10px" }}
                placeholder="מייל"
                value={parentTwoMail}
                id="personalName"
                onChange={(e) => {
                  setParentTwoMail(e.target.value);
                }}
                onBlur={() => {
                  setParentTwoMailTouched(true);
                }}
                isInvalid={parentTwoMailTouched && !parentTwoMailValid}
              />
              <Form.Control
                type="text"
                className="formField"
                style={{ marginBottom: "10px" }}
                placeholder="טלפון"
                value={parentTwoPhone}
                id="personalName"
                onChange={(e) => {
                  setParentTwoPhone(e.target.value);
                }}
                onBlur={() => {
                  setParentTwoPhoneTouched(true);
                }}
                isInvalid={parentTwoPhoneTouched && !parentTwoPhoneValid}
              />
            </Form.Group>
          </>
        ) : null}
      </Form>
      {!(
        parentOneMailValid &&
        parentOnePhoneValid &&
        ((parentOneNameValid && parentOneNameTouched) || studentAge >= 19)
      ) && (
          <div className="validation-message">
            יש למלא את כל השדות הנדרשים של הורה 1
          </div>
        )}
      <div className="form-actions">
        <Button
          variant="secondary"
          className="newtext newsmallerText"
          onClick={() => {
            setNewParentsData({
              parentOneName: parentOneName,
              parentOneMail: parentOneMail,
              parentOnePhone: parentOnePhone,
              parentTwoName: parentTwoName,
              parentTwoMail: parentTwoMail,
              parentTwoPhone: parentTwoPhone,
            });
            setCurrentStep(3);
          }}
        >
          חזור
        </Button>
        <Button
          variant="primary"
          className={`newtext newsmallerText btn btn-primary ${!(
            parentOneMailValid &&
            parentOnePhoneValid &&
            ((parentOneNameValid && parentOneNameTouched) || studentAge >= 19)
          )
            ? "btn-disabled"
            : ""
            }`}
          onClick={() => {
            setNewParentsData({
              parentOneName: parentOneName,
              parentOneMail: parentOneMail,
              parentOnePhone: parentOnePhone,
              parentTwoName: parentTwoName,
              parentTwoMail: parentTwoMail,
              parentTwoPhone: parentTwoPhone,
            });
            setCurrentStep(5);
          }}
          disabled={
            !(
              parentOneMailValid &&
              parentOnePhoneValid &&
              ((parentOneNameValid && parentOneNameTouched) || studentAge >= 19)
            )
          }
        >
          המשך
        </Button>
      </div>
    </div>
  );
}
